﻿const faqSelectSubmitButton = document.getElementById('faq-select-submit');
const faqSelectDropdown = document.getElementById('faq-select');

if (faqSelectDropdown) {
    faqSelectSubmitButton.addEventListener('click', function () {
        let faqSelectValue = faqSelectDropdown.value;

        if (faqSelectValue && faqSelectValue != "") {
            window.location.href = faqSelectValue;
        }
    })
}